module.exports = __webpack_public_path__ + "img/shareImage.faa7fdba.png";